import React from "react";
import { type DetailsProps } from "./types";
import { Detail } from "./components/Detail";
import { detailPresets } from "./js/detailPresets";
import cx from "components/src/utils/cx";
import kebabCase from "lodash-es/kebabCase";

export const Details = ({
  list,
  gap = "2xs",
  noPad = false,
  noWrap = false,
  className = "",
  textSize,
  fgColor,
  dividerColor,
  noMinHeight,
  ...rest
}: DetailsProps) => {
  let firstIsLive: boolean;
  console.log({fgColor})
  const _list = list
    ?.filter((tag) => {
      return !!tag;
    })
    .map((tag, i) => {
      const isFirst = i === 0 || list.length === 1;
      const isLast = i === list.length - 1 || list.length === 1;
      const _key = `cui__details-detail-${kebabCase(
        typeof tag === "string" ? tag : ""
      )}-${i}`;
      const type = tag && "type" in tag ? tag.type : "";
      const _tag = tag && "tag" in tag ? tag.tag : "";
      const preset =
        tag && type && type in detailPresets
          ? detailPresets[type](tag)
          : {};
      const _showDivider =
        isFirst || (i === 1 && firstIsLive)
          ? false
          : !Array.isArray(preset) && typeof preset?.showDivider === "boolean"
          ? preset?.showDivider
          : typeof tag?.showDivider === "boolean"
          ? tag?.showDivider
          : true;

      if (!firstIsLive) {
        firstIsLive = i === 0 && type === "live";
      }
      if (type && typeof type === "string")
        if (type === "live" && i === 0) {
          return list.length === 1 ? (
            <Detail
              textSize={textSize}
              {...preset}
              showDivider={_showDivider}
              isFirst={isFirst}
              isLast={isLast}
              fgColor={fgColor}
              key={_key}
            />
          ) : (
            <Detail
              textSize={textSize}
              {...preset}
              tag=""
              showDivider={_showDivider}
              isFirst={isFirst}
              fgColor={fgColor}
              key={_key}
            />
          );
        } else if (type === "date") {
          return Array.isArray(preset)
            ? preset.map((presetTag, j) => {
                const dateDivider = {
                  showDivider: presetTag?.showDivider
                    ? presetTag?.showDivider
                    : tag?.showDivider,
                };
                return (
                  <Detail
                    textSize={textSize}
                    {...presetTag}
                    showDivider={dateDivider.showDivider}
                    isFirst={i === 0 && j === 0}
                    isLast={isLast && j === preset.length - 1}
                    dividerColor={dividerColor}
                    fgColor={fgColor}
                    key={`${_key}-${j}`}
                  />
                );
              })
            : null;
        } else {
          return (
            <Detail
              textSize={textSize}
              {...preset}
              tag={_tag ? _tag : !Array.isArray(preset) ? preset.tag : ""}
              showDivider={_showDivider}
              isFirst={isFirst}
              isLast={isLast}
              fgColor={fgColor}
              dividerColor={dividerColor}
              key={_key}
            />
          );
        }
      return (
        <Detail
          textSize={textSize}
          {...tag}
          showDivider={_showDivider}
          isFirst={isFirst}
          isLast={isLast}
          fgColor={fgColor}
          dividerColor={dividerColor}
          key={_key}
        />
      );
    })
    .filter((tag) => {
      return !!tag;
    });
    
  if (!_list?.length) return null;

  return (
    <div
      className={cx(
        {
          "cui-py-1": !noPad,
          "cui-flex-wrap": !noWrap,
          "cui-min-h-[26px]": !noMinHeight,
          [className]: !!className,
        },
        "cui__details cui-flex cui-items-center cui-gap-y-2px"
      )?.trim()}
      {...rest}
    >
      {_list}
    </div>
  );
};
